import { Component, Input, NgZone, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { CNProtocol } from 'src/app/models/cnprotocol';
import * as moment from 'moment';
import { ItemAccessDialogComponent } from 'src/app/dialogs/item/item-access-dialog/item-access-dialog.component';
import { PatientService } from 'src/app/services/patient.service';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { RecordContainerMode } from '../../record/record-container/record-container.component';
import { ProtocolEditDialogComponent } from 'src/app/dialogs/protocol/protocol-edit-dialog/protocol-edit-dialog.component';

declare var Ext: any;

@ManageType('ProtocolRowComponent')
@Component({
  selector: 'app-protocol-row',
  templateUrl: './protocol-row.component.html',
  styleUrls: ['./protocol-row.component.scss']
})
export class ProtocolRowComponent implements OnInit {

  @Input() record: CNProtocol;
  @Input() mode: RecordContainerMode = RecordContainerMode.compact;

  private useOldInterface = false;

  constructor(private patient: PatientService, private dialog: MatDialog, private ngZone: NgZone) { }

  ngOnInit(): void {
  }

  editProtocol() {
    if (this.useOldInterface) {
      this.ngZone.runOutsideAngular(() => {
        setTimeout(() => {
          const protocol = new Ext.CNProtocol(this.record.id);
          protocol.on('itemLoaded', (item) => {
            const windowParams = new Array();
            const protocolWindow = new Ext.CNProtocolWindow({
              protocol: item,
              patientid: this.patient.patientid
            });
            protocolWindow.on('added', () => {
            });
            protocolWindow.show();
          });
        });
      });
    } else {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = {
          patient: this.patient.patient,
          protocol: this.record
      };
      const dialogRef = this.dialog.open(ProtocolEditDialogComponent, dialogConfig);  
    }
  }

  get date() {
    return moment(this.record.date).format('DD/MM/YYYY');
  }

  get content() {
    return this.record.value;
  }

  get files() {
    const fileids: string[] = [];
    this.record.childs$('stvaast_protocol_file').forEach(afile => {
      fileids.push(afile.id.toString());
    });
    return fileids;
  }

  openAccess() {
    const dialogRef = this.dialog.open(ItemAccessDialogComponent, {
      data: {
        item: this.record
      },
      maxWidth: '60%',
      minWidth: '480px'
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }
}
